import { render, staticRenderFns } from "./overview_info.vue?vue&type=template&id=3dc37e21&scoped=true"
import script from "./overview_info.vue?vue&type=script&lang=js"
export * from "./overview_info.vue?vue&type=script&lang=js"
import style0 from "./overview_info.vue?vue&type=style&index=0&id=3dc37e21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc37e21",
  null
  
)

export default component.exports